const { sessionStorage, localStorage } = window;
export const storageKey = 'rezdy';

export const loadState = (key: string, local: boolean = false) => {
    try {
        const storage = local ? localStorage : sessionStorage;
        const serializedState = storage.getItem(`${storageKey}:${key}`);
        if (serializedState === null) {
            return undefined;
        }
        return JSON.parse(serializedState);
    } catch (err) {
        return undefined;
    }
};

export const saveState = (key: string, state: any, local: boolean = false) => {
    try {
        const storage = local ? localStorage : sessionStorage;
        const serializedState = JSON.stringify(state);
        storage.setItem(`${storageKey}:${key}`, serializedState);
        return true;
    } catch (error) {
        return false;
    }
};

export default {
    loadState,
    saveState,
};
